import React from "react";
import Seo from "../components/seo";
import Matrix from "../components/matrix";
import Layout from "../components/layout";
import SectionHead from "../components/newComponents/sectionHead";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, ProjectEntryData } from "../queries";
import SocialMediaButtons from "../components/newComponents/socialShare";

const countries = {"coteDivoire": "Côte d'Ivoire", "eswatini" : "eSwatini"};

export function ProjectsEntry()
{
    let { slug } = useParams();

    const query_state = useQuery(ProjectEntryData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data;
    const { entry } = data; 

    return(
  <Layout>
    <Seo title={entry[0].title} image={entry[0].featureImage[0]?.url} />
    <div className="main">
      <section className="section-inside" style={{ padding: "0" }}>
        <div className="shell">
          <SectionHead heading={entry[0].title} image={entry[0].featureImage[0]}/>
          <div className="section__inner">
            <aside className="section__aside">
              <ul className="list-info">
                {entry[0].relatedFocusArea.length > 0 ?
                  <li>
                    <p className="list__title"><strong>Focus Area: </strong></p>
                    <p className="list__details">
                      {entry[0].relatedFocusArea.map((item) => (
                        <>
                          {item.title}
                          <br/>
                        </>
                      ))}
                    </p>
                  </li>
                  :
                  <></>
                }
                {entry[0].relatedAreaOfExpertise.length > 0 ?
                  <li>
                    <p className="list__title">
                      <strong>Area of Expertise: </strong>
                    </p>
                    <p className="list__details">
                      {entry[0].relatedAreaOfExpertise.map((item) => (
                        <>
                          {item.title}
                          <br/>
                        </>
                      ))}
                    </p>
                  </li>
                  :
                  <></>
                }
                {entry[0].clientName ? 
                  <li>
                    <p className="list__title"><strong>Client: </strong></p>
                    <p className="list__details">{entry[0].clientName}</p>
                  </li>
                  :
                  <></>
                }
                {entry[0].countries.length > 0 ?
                  <li>
                    <p className="list__title"><strong>Countries: </strong></p>
                    <p className="list__details">
                      {entry[0].countries.map((item, i) => {

                        const result = item.replace( /([A-Z])/g, " $1");
                        let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                        if(countries[item]) finalResult = countries[item];
                        
                        return (
                          <>
                            {finalResult}
                            <br/>
                          </>
                        );
                      })}
                    </p>
                  </li>
                  :
                  <></>  
                }
                {entry[0].projectDate ? 
                  <li>
                    <p className="list__title"><strong>Date:</strong></p>
                    <p className="list__details">{entry[0].projectDate}</p>
                  </li>
                  :
                  <></>
                }
                {entry[0].displayTitle ? 
                  <li>
                    <p className="list__title"><strong>Project name: </strong></p>
                    <p className="list__details">{entry[0].displayTitle}</p>
                  </li>
                  :
                  <></>
                }
              </ul>
            </aside>
            <div className="section__content">
              <Matrix blocks={entry[0].bodyContent}/>
              <SocialMediaButtons url={`${entry[0].url}`} title={`Genesis Analytics Project: ${entry[0].title}`} summary={entry[0].summary} twitterVia="GenesisEconomic" linkedInSource="Genesis Analytics"/>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);
};
